module.exports = __webpack_public_path__ + "img/FR.81465a1d.svg";